// json - post
export async function postJson<TIn, TOut>(url: string, request: TIn): Promise<TOut> {

    const r = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
    });

    return await extractDataOrThrowApiError<TOut>(r);
}

// POST NO RETURN
export async function postOk(url: string): Promise<void> {

    const r = await fetch(url, { method: "POST" });
    if (!r.ok) {
        throw await extractError(r);
    }
}

// json - get
export async function getJson<TOut>(url: string): Promise<TOut> {

    const r = await fetch(url);
    return await extractDataOrThrowApiError<TOut>(r);
}

// DELETE NO RETURN
export async function deleteOk(url: string): Promise<void> {

    const r = await fetch(url, { method: "DELETE" });
    if (!r.ok) {
        throw await extractError(r);
    }
}

// generic response extractor
async function extractDataOrThrowApiError<TData>(r: Response): Promise<TData> {
    if (r.ok) {
        const data = await r.json() as TData;
        return data;
    }

    throw await extractError(r);
}

async function extractError(r: Response): Promise<ApiError> {

    const status = r.status;

    // json case
    const content = r.headers.get('Content-Type');
    if (content?.includes('application/json')) {
        const jsonErr = (await r.json()) as ApiError;
        if ("error" in jsonErr && "error_description" in jsonErr) {
            return { ...jsonErr, status };
        }
    }

    const err: ApiError = {
        error: "request_error",
        error_description: `Ошибка код: ${r.status} ${r.statusText}`,
        status: status
    }

    return err;
}

// common error
export type ApiError = {
    error: string;
    error_description: string;
    status?: number;
    errors?: Record<string, string[]>
};

export const apiErrorValidationMessages = (err: ApiError): string[] => {
    const arr = [];
    if (err.errors) {
        for (const v of Object.values(err.errors)) {
            for(const m of v){
                arr.push(m);
            }
        }
    }
    return arr;
}